var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairDryerSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38994 4.3597H5.99994C8.80642 4.29179 11.5534 3.53638 13.9999 2.1597C14.7661 1.77184 15.6097 1.56116 16.4683 1.54324C17.3269 1.52532 18.1785 1.70062 18.9602 2.05617C19.7419 2.41172 20.4337 2.93843 20.9845 3.59736C21.5352 4.25629 21.9308 5.03058 22.1419 5.86298C22.3531 6.69538 22.3745 7.56461 22.2045 8.40638C22.0344 9.24816 21.6774 10.041 21.1597 10.7261C20.642 11.4113 19.977 11.9714 19.2137 12.3649C18.4504 12.7585 17.6084 12.9754 16.7499 12.9997C15.7293 13.0056 14.7266 12.7324 13.8499 12.2097C11.3206 10.793 8.4584 10.0783 5.55994 10.1397H3.38994V4.3597Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39014 2.4502V12.0002",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 9.13982C15.6953 9.13982 14.8402 8.28469 14.8402 7.22982C14.8402 6.17496 15.6953 5.31982 16.7502 5.31982C17.805 5.31982 18.6602 6.17496 18.6602 7.22982C18.6602 8.28469 17.805 9.13982 16.7502 9.13982Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9302 7.22998H9.11018",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3301 12.3301L18.1101 17.8101C17.9977 18.3304 17.7097 18.7962 17.2946 19.1294C16.8795 19.4626 16.3624 19.6429 15.8301 19.6401C15.5747 19.6376 15.3214 19.5937 15.0801 19.5101C14.5364 19.3263 14.0801 18.9476 13.7994 18.4471C13.5187 17.9466 13.4334 17.3598 13.5601 16.8001L14.5601 12.5001",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0801 19.5104L14.5801 20.7504C14.3753 21.2673 14.0198 21.7106 13.5596 22.0228C13.0995 22.3349 12.5561 22.5013 12.0001 22.5004H11.8801C11.1428 22.5004 10.4357 22.2075 9.91432 21.6861C9.39297 21.1648 9.10008 20.4577 9.10008 19.7204V17.2504C9.1014 16.937 9.04081 16.6264 8.92179 16.3365C8.80277 16.0466 8.62767 15.783 8.40654 15.561C8.1854 15.3389 7.92259 15.1627 7.63318 15.0425C7.34377 14.9222 7.03347 14.8603 6.72008 14.8604C6.40622 14.8604 6.09543 14.9222 5.80547 15.0423C5.5155 15.1624 5.25202 15.3384 5.03009 15.5604C4.80816 15.7823 4.63212 16.0458 4.51201 16.3357C4.3919 16.6257 4.33008 16.9365 4.33008 17.2504C4.33139 17.6885 4.24623 18.1226 4.07947 18.5278C3.91271 18.9329 3.66764 19.3012 3.35829 19.6115C3.04894 19.9218 2.6814 20.1679 2.27673 20.3359C1.87206 20.5039 1.43822 20.5904 1.00008 20.5904H0.520079",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairDryerSvgrepocom);
export default __webpack_public_path__ + "static/media/hair-dryer_svgrepo.com.db34145efc618c28188a6d556781e73f.svg";
export { ForwardRef as ReactComponent };